export const licenses = {
    en: {
        teamDiscount: 'Need a team discount? ',
        clickHere: 'Click here!',
        purchaseOptions: 'Purchase Options',
        selectRegion: 'Select your region',
        licenseTitle: "License",
        licenseDemoTitle: "Demo License",
        licenseDemoDescription: "Full access to all features until {expiration}.",
        licenseStandardTitle: "Standard License",
        licenseStandardDescription: "Full access to all features {br} Expires on {expiration}",
        licenseUpgradeButton: "Upgrade to Standard",
        licenseManageSubscription: "Manage Subscription",
        demo: 'Demo',
        standard: 'Standard',
        trial: 'Trial',
        unknown: 'Unknown',
        noLicense: 'No license',
        expiration: 'Expiration',
        licenseType: 'License Type',
        provider: 'Provider',
        subscriptionExpired: "Expired",
        licenseExpired: 'License expired',
        licenseValid: 'Valid license',
        licenseNearExpiration: 'License about to expire',
        subscriptionStatus: 'Subscription Status'
    },
    pt: {
        teamDiscount: 'Quer descontos para sua equipe? ',
        clickHere: 'Conquiste o seu agora!',
        purchaseOptions: 'Opções de Compra',
        selectRegion: 'Selecione sua região',
        licenseTitle: "Licença",
        licenseDemoTitle: "Licença Demonstração",
        licenseDemoDescription: "Acesso completo a todos os recursos até {expiration}.",
        licenseStandardTitle: "Licença Padrão",
        licenseStandardDescription: "Acesso completo a todos os recursos{br}Expira em {expiration}",
        licenseUpgradeButton: "Atualizar para Padrão",
        licenseManageSubscription: "Gerenciar Assinatura",
        demo: 'Demonstração',
        standard: 'Padrão',
        trial: 'Avaliação',
        unknown: 'Desconhecido',
        noLicense: 'Sem licença',
        expiration: 'Expiração',
        licenseType: 'Tipo de Licença',
        provider: 'Fornecedor',
        licenseNearExpiration: 'Licença perto de expirar',
        licenseExpired: 'Licença expirada',
        licenseValid: 'Licença válida',
        subscriptionExpired: 'Expirada',
        subscriptionStatus: 'Status da Assinatura'
    },
    es: {
        teamDiscount: '¿Necesitas descuento para equipos? ',
        clickHere: '¡Haz clic aquí!',
        purchaseOptions: 'Opciones de Compra',
        selectRegion: 'Seleccione su región',
        licenseTitle: "Licencia",
        licenseDemoTitle: "Licencia de Demostración",
        licenseDemoDescription: "Acceso completo a todas las funciones hasta {expiration}.",
        licenseStandardTitle: "Licencia Estándar",
        licenseStandardDescription: "Acceso completo a todas las funciones{br}Expira el {expiration}",
        licenseUpgradeButton: "Actualizar a Estándar",
        licenseManageSubscription: "Administrar Suscripción",
        demo: 'Demostración',
        standard: 'Estándar',
        trial: 'Prueba',
        unknown: 'Desconocido',
        noLicense: 'Sin licencia',
        expiration: 'Expiración',
        licenseType: 'Tipo de Licencia',
        provider: 'Proveedor',
        licenseExpired: 'Licencia expirada',
        licenseValid: 'Licencia válida',
        licenseNearExpiration: 'Licencia a punto de expirar',
        subscriptionExpired: 'Expirada',
        subscriptionStatus: 'Estado de Suscripción'
    }
};

export const licenseDescriptions = {
    en: {
        noLicenseDescription: `
You're enjoying full demo access!

You currently have access to all features:
- 45+ Expert Checklists (step-by-step privacy fixes)
- Dashboard Tracking (monitor your progress)
- Priority Support (humans to the rescue)

To continue protecting yourself after the demo: **Subscribe now!** Payment options on this page`,

        expiredDescription: `
Your License Expired - but you can remain protected

Renew now to regain access to:
- 45+ Expert Checklists (step-by-step privacy fixes)
- Dashboard Tracking (monitor your progress)
- Priority support! - (humans to the rescue)
- Still budget-friendly – our plan costs less than a coffee
- Seamless restore: Pick up right where you left off.

**Renew now!** Payment options are on this page.`,

licensedDescription: `
You are all set!

Enjoy uninterrupted access to:
- 45+ Expert Checklists (step-by-step privacy fixes)
- Dashboard Tracking (real-time progress updates)
- Priority Support (humans to the rescue)

**Pro Tip:** Share the app to earn free months!`
    },
    es: {
        noLicenseDescription: `
Estás disfrutando acceso completo de demostración!

Actualmente tienes acceso a todas las funciones:
- 45+ Checklists de Expertos (soluciones de seguridad paso a paso)
- Tablero de Progreso (monitorea tu avance)
- Soporte Prioritario (humanos al rescate)

Para seguir protegido después de la demo: **¡Suscríbete ahora!** Opciones de pago en esta página.`,

expiredDescription: `
Tu Licencia Venció - pero puedes seguir protegido

Renueva ahora para recuperar acceso a:
- 45+ Checklists de Expertos (soluciones de seguridad paso a paso)
- Tablero de Progreso (monitorea tu avance)
- ¡Soporte prioritario! - (humanos al rescate)
- Sigue siendo económico – nuestro plan cuesta menos que un café
- Continúa sin perder nada: Retoma donde quedaste.

**¡Renueva ahora!** Opciones de pago en esta página.`,

        licensedDescription: `
¡Todo listo!

Disfruta acceso ininterrumpido a:
- 45+ Checklists de Expertos (soluciones de privacidad paso a paso)
- Tablero de Progreso (actualizaciones en tiempo real)
- Soporte Prioritario (humanos al rescate)

**Consejo Pro:** Comparte la app para **ganar meses gratis**.`
    },
    pt: {
        noLicenseDescription: `
Você está com acesso total à versão de demonstração!

Atualmente você tem acesso a todos os recursos:
- 45+ Checklists de Especialistas (soluções de segurança passo a passo)
- Painel de Progresso (acompanhe sua evolução)
- Suporte Prioritário (humanos ao resgate)

Para continuar protegido após a demo: **Assine agora!** Opções de pagamento nesta página.`,

expiredDescription: `
Sua Licença Expirou - mas você pode continuar protegido

Renove agora para reativar:
- 45+ Checklists de Especialistas (soluções de segurança passo a passo)
- Painel de Progresso (acompanhe sua evolução)
- Suporte prioritário! (humanos ao resgate)
- Ainda acessível – nosso plano custa menos que um café
- Continue de onde parou: Sem perder seu progresso

**Renove agora!** Opções de pagamento nesta página.`,

licensedDescription: `
Tudo pronto!

Aproveite acesso contínuo a:
- 45+ Checklists de Especialistas (soluções de privacidade passo a passo)
- Painel de Progresso (atualizações em tempo real)
- Suporte Prioritário (humanos ao resgate)

**Dica Pro:** Indique o app para ganhar meses grátis!`
    }
};
